<template>
 <QS-scroller-box>
  <EchoLastData
       :dataList="boundVehiclePreview"
       :model="renderData.model.topPreviewModel"
     />
     <!-- eslint-disable-next-line vue/no-unused-refs -->
  <AddVehicle ref="AddVehicle"
        :modelId="modelId"
        :addVehicleTable="renderData.model.m_addVehicleModel.carInfoList"
        :maxVehicle='maxVehicle'
        :showBatch="showBatch"
        :m_addVehicle="renderData.list.m_addVehicle"
        :m_addVehicleModel="renderData.model.m_addVehicleModel"
        :selectOrderFormModel="renderData.model.selectOrderFormModel"
      />
  <template slot="bottomAction">
      <el-button @click="cancel" size="mini">取消</el-button>
      <el-button @click="previousStep" size="mini">上一步</el-button>
      <el-button :loading="submitLoading" @click="submit" size="mini" type="primary">提交</el-button>
    </template>
 </QS-scroller-box>
</template>

<script>
import AddVehicle from './AddVehicles.vue'
import EchoLastData from '../../../components/EchoLastData.vue'
import { boundVehiclePreview } from '../../config/echoLastData'
import { addEnterpriseSubOrderRenewalBSignCheck } from '@/api/domain/underLease'

export default {
  components: {
    AddVehicle,
    EchoLastData,
  },
  props: {
    renderData: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      boundVehiclePreview,
      maxVehicle: -1, // 允许添加的最大车辆数  -1 表示不限制
      showBatch: true, // 是否展示批量添加车辆功能
      submitLoading: false,
    }
  },
  computed: {
    modelId() {
      return this.renderData.model.vehicleModelModel.modelId
    },
  },
  methods: {
    cancel() {
      this.$emit('cancel')
    },
    previousStep() {
      this.$emit('previousStep')
    },
    // eslint-disable-next-line vue/no-unused-properties
    confirm() {
      this.$emit('confirm')
    },
    // 获取参数
    getParameter() {
      const { selectOrderFormModel, selectOrderTextModel, leaseSchemeModel, vehicleModelModel, leaseInfoParams, tableDataFrom, m_addVehicleModel } = this.renderData.model
      console.log('freedomCycle', leaseInfoParams)
      leaseInfoParams.startDate = leaseInfoParams.startStopDate[0]
      leaseInfoParams.endDate = leaseInfoParams.startStopDate[1]
      // leaseInfoParams.presentStartDate = leaseInfoParams.freedomCycle[0]
      // leaseInfoParams.presentEntDate = leaseInfoParams.freedomCycle[1]
      tableDataFrom.tableData && tableDataFrom.tableData.forEach((ele) => {
        // this.leaseInfoParams.category === 3：类别为司机合作模式
        // fundType === 1：收款项为租金
        if (ele.fundType === 1 && leaseInfoParams.category === 3) {
          ele.planAmount = ''
          ele.payDay = ''
          ele.payPost = ''
          ele.presentDays = ''
          ele.totalCycle = ''
          ele.payDate = ''
          ele.payMode = ''
        }
      })
      const params = {
        // 选择客户
        customerId: selectOrderFormModel.customerId,
        orderId: selectOrderFormModel.entRentOrderId,
        customerName: selectOrderTextModel.customerName,
        rentCalculationRules: selectOrderTextModel.customerType,
        // 租赁设置
        ...leaseSchemeModel,
        ...vehicleModelModel,
        ...leaseInfoParams,
        rentCategory: leaseInfoParams.rentCategory || leaseInfoParams.category,
        orderAccruedPlans: tableDataFrom.tableData,
        // 绑定车辆
        carInfoList: m_addVehicleModel.carInfoList,
      }
      return params
    },
    // 提交
    submit() {
      if (this.submitLoading) return
      this.$confirm('选择提交，将创建子订单信息，创建后将不可修改租赁信息，是否选择继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '再想想',
        type: 'warning',
      }).then(async () => {
        this.submitLoading = true
        try {
          if (!this.renderData.model.m_addVehicleModel.carInfoList.length) {
            this.$message.error('请先选择车辆')
            return
          }
          // 租赁信息校验
          const res = await addEnterpriseSubOrderRenewalBSignCheck({
            ...this.getParameter(),
          })
          const { code } = res
          if (code === 1) {
            this.handlerPreview()
            this.$emit('submit')
          }
        } finally {
          this.submitLoading = false
        }
      }).catch((error) => {
        if (error.code === 22049) {
          this.$message.error('租赁方案已下架，点击【上一步】重新选择租赁方案')
        }
      })
    },
    handlerPreview() {
      const { topPreviewModel, m_addVehicleModel } = this.renderData.model
      topPreviewModel.num = `${m_addVehicleModel?.carInfoList?.length || 0}台`
    },
  },
}
</script>

<style scoped lang='scss'>
.control{
  padding: 5px 10px;
  background: #F7F8FA;
  text-align: right;
  .batchTemplateDown{
    display: inline-block;
    margin-right: 10px;
    color: #276BEC;
    cursor: pointer;
  }
}
</style>
